
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class MarkupChargesDialog extends Common.GridEditorDialog<MarkupChargesRow> {
        protected getFormKey() { return MarkupChargesForm.formKey; }
        protected getLocalTextPrefix() { return MarkupChargesRow.localTextPrefix; }

        protected form = new MarkupChargesForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.MarkUp);
            this.form.MarkUpType.changeSelect2(e => {
                var type = this.form.MarkUpType.value;
                Q.reloadLookup("ProductsTypeLookup");
                this.clearAllValues();
                this.setFields();
                //if (type == "1") {
                //    q.showAndSetRequiredField(this.form.ItemTypeId);
                //    q.showAndSetRequiredField(this.form.ProductTypeId);
                //    q.showAndEnableField(this.form.CategoryId);
                //    q.showAndEnableField(this.form.SubCategoryId);
                //    q.hideField(this.form.BrandId);
                //    q.hideField(this.form.CollectionId);
                //    q.hideField(this.form.SuperTypeId);
                //    q.hideField(this.form.ProcessId);

                //} else if (type == "2") { 
                //    q.hideField(this.form.ItemTypeId);
                //    q.showAndSetRequiredField(this.form.ProductTypeId);
                //    q.showAndEnableField(this.form.CategoryId);
                //    q.showAndEnableField(this.form.SubCategoryId);
                //    q.showAndEnableField(this.form.BrandId);
                //    q.showAndEnableField(this.form.CollectionId);
                //    q.showAndEnableField(this.form.SuperTypeId);
                //    q.showAndEnableField(this.form.ProcessId);
                //}
            });
            this.form.ItemTypeId.changeSelect2(e => {
                this.form.ProductTypeId.cascadeField = "ItemTypeId";
                this.form.ProductTypeId.cascadeValue = this.form.ItemTypeId.value;
            });
            this.form.ProductTypeId.changeSelect2(e => {
                var itemtypeid = OMS.ProductTypeRow.getLookup().itemById[this.form.ProductTypeId.value].ItemTypeId;
                if (itemtypeid == 101) {
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.showAndEnableField(this.form.BrandId);
                    q.showAndEnableField(this.form.CollectionId);
                    q.showAndEnableField(this.form.SuperTypeId);
                } else if (itemtypeid == 104) {
                    q.showAndEnableField(this.form.KaratId);
                    q.showAndEnableField(this.form.MetalColorId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.BrandId);
                    q.hideField(this.form.CollectionId);
                    q.hideField(this.form.SuperTypeId);
                } else if (itemtypeid == 105) {
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.showAndEnableField(this.form.ShapeId);
                    q.showAndEnableField(this.form.StoneSizeId);
                    q.showAndEnableField(this.form.SieveId);
                    q.showAndEnableField(this.form.QualityId);
                    q.showAndEnableField(this.form.StoneColorId);
                    q.hideField(this.form.BrandId);
                    q.hideField(this.form.CollectionId);
                    q.hideField(this.form.SuperTypeId);
                }
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })
            this.form.ProcessId.changeSelect2(e => {
                Q.reloadLookup(OMS.ProcessMasterRow.lookupKey);
                var isSetting = OMS.ProcessMasterRow.getLookup().itemById[this.form.ProcessId.value].IsSetting;
                if (isSetting)
                    q.showAndSetRequiredField(this.form.SettingId);
                else
                    q.hideField(this.form.SettingId);

            })
        }

        afterLoadEntity() {
            super.afterLoadEntity();
            this.setFields();
        }

        clearAllValues() {
            this.form.ItemTypeId.value = "";
            this.form.ProductTypeId.value = "";
            this.form.CategoryId.value = "";
            this.form.SubCategoryId.value = "";
            this.form.BrandId.value = "";
            this.form.CollectionId.value = "";
            this.form.SuperTypeId.value = "";
            this.form.ShapeId.value = "";
            this.form.StoneSizeId.value = "";
            this.form.SieveId.value = "";
            this.form.QualityId.value = "";
            this.form.StoneColorId.value = "";
            this.form.KaratId.value = "";
            this.form.MetalColorId.value = "";
            this.form.ProcessId.value = "";
            this.form.SettingId.value = "";
        }

        setFields() {
            // if (this.entityId != null) {
            if (this.form.MarkUpType.value != "") {
                var type = this.form.MarkUpType.value;
                Q.reloadLookup("ProductsTypeLookup");
                if (type == "1") {
                    q.hideField(this.form.ProcessId);
                    q.hideField(this.form.SettingId);
                    if (!Q.isEmptyOrNull(this.form.ProductTypeId.value)) {
                        var itemtypeid = OMS.ProductTypeRow.getLookup().itemById[this.form.ProductTypeId.value].ItemTypeId;
                        if (itemtypeid == 101) {
                            let compmarkupconfig = q.ToBool(TabAurous.GetConfigValue(1038));
                            q.hideField(this.form.KaratId);
                            q.hideField(this.form.MetalColorId);
                            q.hideField(this.form.ShapeId);
                            q.hideField(this.form.StoneSizeId);
                            q.hideField(this.form.SieveId);
                            q.hideField(this.form.QualityId);
                            q.hideField(this.form.StoneColorId);
                            q.showAndEnableField(this.form.BrandId);
                            q.showAndEnableField(this.form.CollectionId);
                            q.showAndEnableField(this.form.SuperTypeId);
                        } else if (itemtypeid == 104) {
                            let compmarkupconfig = parseInt(TabAurous.GetConfigValue(1040));
                            switch (compmarkupconfig) {
                                case 1:
                                    q.showAndSetRequiredField(this.form.ItemTypeId);
                                    q.showAndSetRequiredField(this.form.ProductTypeId);
                                    q.showAndSetRequiredField(this.form.CategoryId);
                                    q.showAndSetRequiredField(this.form.SubCategoryId);
                                    q.showAndEnableField(this.form.KaratId);
                                    q.showAndEnableField(this.form.MetalColorId);
                                    q.hideField(this.form.ShapeId);
                                    q.hideField(this.form.StoneSizeId);
                                    q.hideField(this.form.SieveId);
                                    q.hideField(this.form.QualityId);
                                    q.hideField(this.form.StoneColorId);
                                    q.hideField(this.form.BrandId);
                                    q.hideField(this.form.CollectionId);
                                    q.hideField(this.form.SuperTypeId);

                                    break;
                                case 2:
                                    q.hideField(this.form.ItemTypeId);
                                    q.showAndSetRequiredField(this.form.ProductTypeId);
                                    q.showAndSetRequiredField(this.form.CategoryId);
                                    q.hideField(this.form.SubCategoryId);
                                    q.hideField(this.form.KaratId);
                                    q.hideField(this.form.MetalColorId);
                                    q.hideField(this.form.ShapeId);
                                    q.hideField(this.form.StoneSizeId);
                                    q.hideField(this.form.SieveId);
                                    q.hideField(this.form.QualityId);
                                    q.hideField(this.form.StoneColorId);
                                    q.hideField(this.form.BrandId);
                                    q.hideField(this.form.CollectionId);
                                    q.hideField(this.form.SuperTypeId);
                                    break;

                            }

                        } else if (itemtypeid == 105) {
                            let compmarkupconfig = parseInt(TabAurous.GetConfigValue(1039));
                            q.hideField(this.form.KaratId);
                            q.hideField(this.form.MetalColorId);
                            switch (compmarkupconfig) {
                                case 1:
                                    q.showAndSetRequiredField(this.form.ItemTypeId);
                                    q.showAndSetRequiredField(this.form.ProductTypeId);
                                    q.showAndSetRequiredField(this.form.CategoryId);
                                    q.showAndSetRequiredField(this.form.SubCategoryId);
                                    q.showAndSetRequiredField(this.form.ShapeId);
                                    q.showAndSetRequiredField(this.form.StoneSizeId);
                                    q.showAndSetRequiredField(this.form.SieveId);
                                    q.showAndSetRequiredField(this.form.QualityId);
                                    q.showAndSetRequiredField(this.form.StoneColorId);

                                    q.hideField(this.form.KaratId);
                                    q.hideField(this.form.MetalColorId);
                                    q.hideField(this.form.BrandId);
                                    q.hideField(this.form.CollectionId);
                                    q.hideField(this.form.SuperTypeId);
                                    break;
                                case 2:
                                    q.hideField(this.form.ItemTypeId);
                                    q.showAndSetRequiredField(this.form.ProductTypeId);
                                    q.hideField(this.form.CategoryId);
                                    q.hideField(this.form.SubCategoryId);
                                    q.showAndSetRequiredField(this.form.ShapeId);
                                    q.hideField(this.form.StoneSizeId);
                                    q.hideField(this.form.SieveId);
                                    q.hideField(this.form.QualityId);
                                    q.hideField(this.form.StoneColorId);

                                    q.hideField(this.form.KaratId);
                                    q.hideField(this.form.MetalColorId);
                                    q.hideField(this.form.BrandId);
                                    q.hideField(this.form.CollectionId);
                                    q.hideField(this.form.SuperTypeId);
                                    break;
                                case 3:
                                    q.hideField(this.form.ItemTypeId);
                                    q.showAndSetRequiredField(this.form.ProductTypeId);
                                    q.hideField(this.form.CategoryId);
                                    q.hideField(this.form.SubCategoryId);
                                    q.showAndSetRequiredField(this.form.ShapeId);
                                    q.showAndSetRequiredField(this.form.StoneSizeId);
                                    q.hideField(this.form.SieveId);
                                    q.hideField(this.form.QualityId);
                                    q.hideField(this.form.StoneColorId);
                                    q.hideField(this.form.KaratId);
                                    q.hideField(this.form.MetalColorId);
                                    q.hideField(this.form.BrandId);
                                    q.hideField(this.form.CollectionId);
                                    q.hideField(this.form.SuperTypeId);
                                    break;
                            }

                        }
                    }
                    else {
                        q.showAndSetRequiredField(this.form.ProductTypeId);
                    }
                } else if (type == "2") {
                    Q.reloadLookup("ProductsTypeLookup");
                    let labormarkupconfig = parseInt(TabAurous.GetConfigValue(1038));
                    switch (labormarkupconfig) {
                        case 1:
                            q.hideField(this.form.ItemTypeId);
                            q.hideField(this.form.ProductTypeId);
                            q.hideField(this.form.CategoryId);
                            q.hideField(this.form.SubCategoryId);
                            q.hideField(this.form.BrandId);
                            q.hideField(this.form.CollectionId);
                            q.hideField(this.form.SuperTypeId);
                            q.hideField(this.form.ShapeId);
                            q.hideField(this.form.StoneSizeId);
                            q.hideField(this.form.SieveId);
                            q.hideField(this.form.QualityId);
                            q.hideField(this.form.StoneColorId);
                            q.hideField(this.form.KaratId);
                            q.hideField(this.form.MetalColorId);
                            q.hideField(this.form.BrandId);
                            q.showAndSetRequiredField(this.form.ProcessId);
                            break;
                    }

                    if (this.form.ProcessId.value != "") {
                        var isSetting = OMS.ProcessMasterRow.getLookup().itemById[this.form.ProcessId.value].IsSetting;
                        if (isSetting)
                            q.showAndSetRequiredField(this.form.SettingId);
                        else
                            q.hideField(this.form.SettingId);
                    }

                }

            }
            else {
                this.form.ItemTypeId.cascadeField = ""
                q.hideField(this.form.ItemTypeId);
                q.hideField(this.form.ProductTypeId);
                q.hideField(this.form.CategoryId);
                q.hideField(this.form.SubCategoryId);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.KaratId);
                q.hideField(this.form.MetalColorId);
                q.hideField(this.form.ProcessId);
                q.hideField(this.form.SettingId);
            }
        }

    }
}